<template>
  <v-container>
    <vue-dropzone
      id="photos-dropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      @vdropzone-file-added="customAddFile"
      >
        <div class="dropzone-custom-content">
          <h3 class="dropzone-custom-title">{{ $t('drag_drop_images') }}</h3>
          <div class="subtitle">{{ $t('select_from_computer') }}</div>
          <div class="dz-message" data-dz-message><span>
            {{ $t('images_no_upload') }}</span></div>
        </div>
    </vue-dropzone>
  </v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'RequestPhotos',
  components: {
    vueDropzone: vue2Dropzone
  },
  data: vm => ({
    dropzoneOptions: {
      url: '#',
      autoProcessQueue: false,
      addRemoveLinks: true,
      thumbnailWidth: 150,
      maxFilesize: 5,
      acceptedFiles: 'image/*'
    }
  }),
  methods: {
    customAddFile: function (file) {
      if (file.type.match(/image.*/)) {
        this.$refs.myVueDropzone.dropzone.emit('complete', file)
      } else {
        this.$refs.myVueDropzone.removeFile(file)
      }
    },
    getImages: function () {
      return this.$refs.myVueDropzone.getQueuedFiles()
    },
    setImage: function (filename, blob) {
      blob.name = filename

      const shortname = filename.substr(filename.indexOf('/') + 1)
      const mimeString = 'image/' + filename.split('.').pop()
      const tempFile = new File([blob], shortname, { type: mimeString })

      this.$refs.myVueDropzone.dropzone.handleFiles([tempFile])
    },
    reset: function () {
      this.$refs.myVueDropzone.dropzone.removeAllFiles()
    }
  }
}
</script>
